import React from 'react'

const YearlyTick: React.FC<any> = ({ x, y, payload, chartType, barSize }) => {
  const { value, index } = payload

  const date = new Date(value)
  const month = date.getMonth()
  const year = date.getFullYear()

  const tickLineHeight = chartType === 'line' ? 45 : 52

  const lineCoordinates = {
    x: x + (chartType === 'line' ? 0 : (-barSize || 0) / 2),
    y: y + (chartType === 'line' ? 21 + 15 : 21)
  }

  const textCoordinates = {
    x: x + 5 + (chartType === 'line' ? 0 : 5 + (-barSize || 0) / 2),
    y: y + 8
  }

  if (!month || !index) {
    return (
      <g>
        <path
          d={`M${lineCoordinates.x},${lineCoordinates.y}v${-tickLineHeight}`}
          stroke="#E1E8FE"
        />
        <text
          x={textCoordinates.x}
          y={textCoordinates.y}
          textAnchor="start"
          fill="#858FAD"
          fontSize={12}
          fontWeight={400}
          fontFamily="Navigo"
        >
          {year}
        </text>
      </g>
    )
  }

  return null
}

export default YearlyTick
